import { Benefits } from './Benefits';

export type { TypeBenefitsProps } from './types';
export default Benefits;
